module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": _vm.isMovil ? '100%' : '450',
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil
    },
    model: {
      value: (_vm.showModalFormEvent),
      callback: function($$v) {
        _vm.showModalFormEvent = $$v
      },
      expression: "showModalFormEvent"
    }
  }, [(_vm.showModalFormEvent) ? _c('form-cita', {
    attrs: {
      "id": _vm.idCita
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEventSelected()
      },
      "update": _vm.getEvents
    }
  }) : _vm._e()], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Programación de citas")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Crea, edita y elimina algunas citas")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.prev()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _c('v-select', {
    staticClass: "ma-1",
    attrs: {
      "items": _vm.types,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "solo": "solo",
      "hide-details": "",
      "label": "Visualizar por"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.next()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.showEvent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "info",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.getEvents()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1)], 1), _c('v-sheet', {
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 183px)' : 'calc(100vh - 133px)'
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    attrs: {
      "event-ripple": false,
      "first-time": _vm.horaInicioDeIntervalo,
      "interval-count": _vm.countIntervals,
      "color": "primary",
      "type": _vm.type,
      "interval-minutes": _vm.intervaloProgramacionCitas,
      "events": _vm.events,
      "short-weekdays": _vm.isMovil,
      "weekdays": _vm.weekday,
      "interval-format": _vm.intervalFormatter,
      "interval-height": _vm.isMovil ? 40 : 27,
      "event-color": _vm.checkBGColorEvent,
      "event-text-color": _vm.checkColorEvent
    },
    on: {
      "change": _vm.getEvents,
      "click:event": _vm.showEvent,
      "click:date": _vm.showDay
    },
    scopedSlots: _vm._u([{
      key: "event",
      fn: function(ref) {
        var event = ref.event;
        var timed = ref.timed;
        var eventSummary = ref.eventSummary;

        return [_c('div', {
          staticClass: "v-event-draggable animated fadeInUp faster my-event",
          attrs: {
            "dark": "dark",
            "width": "100%"
          }
        }, [_c('v-chip', {
          staticClass: "px-2 mx-1",
          attrs: {
            "color": event.ingresadoAtaller ? 'success white--text' : 'orange white--text',
            "dark": event.ingresadoAtaller ? true : false,
            "x-small": "x-small",
            "to": !_vm.isMovil ? ("/ticket/" + (event.numeroTicket)) : ''
          }
        }, [_c('v-icon', {
          attrs: {
            "size": _vm.isMovil ? 2 : 6,
            "color": event.ingresadoAtaller ? 'white' : ''
          }
        }, [_vm._v("circle")]), _c('span', {
          class: {
            'white--text': event.ingresadoAtaller, 'font-size-10': _vm.isMovil, 'font-weight-700': !_vm.isMovil
          }
        }, [_vm._v(" " + _vm._s(("" + (event.numeroTicket))))])], 1), _c('span', {
          class: _vm.isMovil ? 'font-size-10' : ' font-size-11 font-weight-700'
        }, [_vm._v(" " + _vm._s(event.name && event.name.split(' - ')[0]) + " ")]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7500a662","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_programacion_de_citas.vue
// module id = 510
// module chunks = 1